import React, { useState, useEffect } from 'react'
import { getMoscowProgressBatch } from '../lib/api'

const REGIONS = ['АФРИКА', 'АЗИЯ', 'ЛАТАМ', 'МОСКВА']

const TOTAL_TASKS = 24

function progressColor(pct) {
  if (pct >= 71) return '#639922'
  if (pct >= 31) return '#EF9F27'
  return '#bbb'
}

export default function Board({ locations, candidates, statusColors, onMoveCandidate, onAddCandidate, onEditLocation, onAddLocation, onClickCandidate, isViewer, isAdmin, onReorderLocations, currentUserId }) {
  const [activeRegion, setActiveRegion] = useState('АФРИКА')
  const [search, setSearch] = useState('')
  const [onlyMine, setOnlyMine] = useState(false)
  const [locFilter, setLocFilter] = useState(new Set())
  const [showLocFilter, setShowLocFilter] = useState(false)
  const [responsibleFilter, setResponsibleFilter] = useState('')
  const [moscowProgress, setMoscowProgress] = useState({})

  const regionLocations = locations.filter(l => {
    if ((l.region || 'АФРИКА') !== activeRegion) return false
    if (locFilter.size > 0 && !locFilter.has(l.id)) return false
    return true
  })
  const responsibleNames = [...new Set(candidates.map(c => c.responsible_name).filter(Boolean))].sort()

  const filteredCandidates = candidates.filter(c => {
    if (onlyMine && c.responsible_id !== currentUserId) return false
    if (isAdmin && responsibleFilter && c.responsible_name !== responsibleFilter) return false
    if (!search) return true
    const q = search.toLowerCase()
    const locName = locations.find(l => l.id === c.location_id)?.name || ''
    return c.name?.toLowerCase().includes(q) || c.passport?.toLowerCase().includes(q) || locName.toLowerCase().includes(q) || c.city?.toLowerCase().includes(q)
  })

  const getCandidatesForLocation = (locId) =>
    filteredCandidates.filter(c => c.location_id === locId)

  useEffect(() => {
    if (activeRegion !== 'МОСКВА') return
    const moscowLocs = locations.filter(l => (l.region || 'АФРИКА') === 'МОСКВА')
    const ids = candidates
      .filter(c => moscowLocs.some(l => l.id === c.location_id))
      .map(c => c.id)
    if (!ids.length) return
    getMoscowProgressBatch(ids).then(setMoscowProgress).catch(() => {})
  }, [activeRegion, candidates, locations])

  return (
    <div>
      <div style={{ display: 'flex', gap: 6, marginBottom: 16, flexWrap: 'wrap' }}>
        {REGIONS.map(region => (
          <button key={region} onClick={() => setActiveRegion(region)} style={{
            fontSize: 13, padding: '7px 16px', borderRadius: 8, border: 'none', cursor: 'pointer',
            background: activeRegion === region ? '#1a1a1a' : '#e8e8e5',
            color: activeRegion === region ? 'white' : '#444',
            fontWeight: activeRegion === region ? 600 : 400
          }}>
            {region === 'АФРИКА' ? '🌍' : region === 'АЗИЯ' ? '🌏' : region === 'ЛАТАМ' ? '🌎' : '🏛'} {region}
            <span style={{ marginLeft: 6, fontSize: 11, opacity: 0.7 }}>
              {filteredCandidates.filter(c => locations.find(l => l.id === c.location_id)?.region === region).length}
            </span>
          </button>
        ))}
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap', alignItems: 'center' }}>
        {currentUserId && (
          <button onClick={() => setOnlyMine(v => !v)} style={{ fontSize: 12, padding: '5px 12px', borderRadius: 8, border: '1px solid ' + (onlyMine ? '#1a1a1a' : '#e0e0dc'), background: onlyMine ? '#1a1a1a' : 'white', color: onlyMine ? 'white' : '#444', cursor: 'pointer', fontWeight: onlyMine ? 600 : 400 }}>
            👤 Только мои
          </button>
        )}
        <div style={{ position: 'relative' }} onBlur={e => { if (!e.currentTarget.contains(e.relatedTarget)) setShowLocFilter(false) }} tabIndex={-1}>
          <button onClick={() => setShowLocFilter(v => !v)} style={{ fontSize: 12, padding: '5px 12px', borderRadius: 8, border: '1px solid ' + (locFilter.size > 0 ? '#1a1a1a' : '#e0e0dc'), background: locFilter.size > 0 ? '#1a1a1a' : 'white', color: locFilter.size > 0 ? 'white' : '#444', cursor: 'pointer' }}>
            🏙 Города {locFilter.size > 0 ? `(${locFilter.size})` : ''}
          </button>
          {showLocFilter && (
            <div style={{ position: 'absolute', top: '100%', left: 0, marginTop: 4, background: 'white', border: '1px solid #e0e0dc', borderRadius: 10, padding: '10px 14px', zIndex: 100, boxShadow: '0 4px 16px rgba(0,0,0,0.1)', minWidth: 200, maxHeight: 300, overflowY: 'auto' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8, fontSize: 11 }}>
                <span style={{ color: '#888' }}>Фильтр городов</span>
                {locFilter.size > 0 && <button onClick={() => setLocFilter(new Set())} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#E24B4A', fontSize: 11 }}>Сбросить</button>}
              </div>
              {locations.filter(l => (l.region || 'АФРИКА') === activeRegion).map(l => (
                <label key={l.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 0', fontSize: 13, cursor: 'pointer' }}>
                  <input type="checkbox" checked={locFilter.has(l.id)} onChange={e => {
                    setLocFilter(prev => { const n = new Set(prev); e.target.checked ? n.add(l.id) : n.delete(l.id); return n })
                  }} />
                  {l.icon} {l.name}
                  <span style={{ marginLeft: 'auto', fontSize: 11, color: '#aaa' }}>{candidates.filter(c => c.location_id === l.id).length}</span>
                </label>
              ))}
            </div>
          )}
        </div>
        {isAdmin && responsibleNames.length > 0 && (
          <select value={responsibleFilter} onChange={e => setResponsibleFilter(e.target.value)}
            style={{ fontSize: 12, padding: '5px 10px', borderRadius: 8, border: '1px solid ' + (responsibleFilter ? '#1a1a1a' : '#e0e0dc'), background: responsibleFilter ? '#1a1a1a' : 'white', color: responsibleFilter ? 'white' : '#444', cursor: 'pointer' }}>
            <option value="">👤 Ответственный</option>
            {responsibleNames.map(n => <option key={n} value={n}>{n}</option>)}
          </select>
        )}
        {(onlyMine || locFilter.size > 0 || responsibleFilter) && (
          <button onClick={() => { setOnlyMine(false); setLocFilter(new Set()); setResponsibleFilter('') }} style={{ fontSize: 11, padding: '5px 10px', borderRadius: 8, border: '1px solid #e0e0dc', background: 'white', color: '#888', cursor: 'pointer' }}>✕ Сбросить всё</button>
        )}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12 }}>
        {regionLocations.map(loc => {
          const locCandidates = getCandidatesForLocation(loc.id)
          return (
            <div key={loc.id} style={{ background: 'white', border: '1px solid #e8e8e5', borderRadius: 12, overflow: 'hidden' }}>
              <div style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0ec', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#fafaf8' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span style={{ fontSize: 16 }}>{loc.icon || '📍'}</span>
                  <span style={{ fontWeight: 600, fontSize: 13 }}>{loc.name}</span>
                  <span style={{ fontSize: 11, color: '#aaa' }}>{locCandidates.length}</span>
                </div>
                {isAdmin && (
                  <button onClick={() => onEditLocation(loc)} style={{ fontSize: 11, color: '#aaa', background: 'transparent', border: 'none', cursor: 'pointer' }}>✏</button>
                )}
              </div>
              <div style={{ padding: 8, minHeight: 60 }}>
                {locCandidates.length === 0 && (
                  <div style={{ fontSize: 11, color: '#ccc', textAlign: 'center', padding: '12px 0' }}>Нет кандидатов</div>
                )}
                {locCandidates.map(c => {
                  const prog = moscowProgress[c.id]
                  const pct = prog ? Math.round(prog.done / TOTAL_TASKS * 100) : null
                  return (
                    <div key={c.id} onClick={() => onClickCandidate(c)} className="board-candidate-card" style={{ padding: '8px 10px', borderRadius: 8, marginBottom: 6, cursor: 'pointer', background: '#f9f9f7', border: '1px solid #efefec', transition: 'background 0.15s' }}
                      onMouseOver={e => e.currentTarget.style.background = '#f0f0ec'}
                      onMouseOut={e => e.currentTarget.style.background = '#f9f9f7'}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        {c.photo_url && <img src={c.photo_url} alt={c.name} style={{ width: 24, height: 24, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />}
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{c.name}</div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 2 }}>
                            <div style={{ width: 6, height: 6, borderRadius: '50%', background: statusColors[c.status] || '#aaa', flexShrink: 0 }} />
                            <span style={{ fontSize: 10, color: '#888' }}>{c.status}</span>
                          </div>
                          {pct !== null && (
                            <div style={{ marginTop: 5 }}>
                              <div style={{ height: 3, borderRadius: 2, background: '#efefec', overflow: 'hidden' }}>
                                <div style={{ height: '100%', width: pct + '%', background: progressColor(pct), borderRadius: 2, transition: 'width 0.4s' }} />
                              </div>
                              <div style={{ fontSize: 9, color: '#aaa', marginTop: 2 }}>{prog.done}/{TOTAL_TASKS} задач оформления</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          )
        })}
        {isAdmin && (
          <div onClick={() => onAddLocation(activeRegion)} style={{ border: '2px dashed #e0e0dc', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 80, cursor: 'pointer', color: '#bbb', fontSize: 13 }}>
            + Локация
          </div>
        )}
      </div>
    </div>
  )
}
